import React, { useState, useEffect } from "react"
import { Doughnut } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'

// Register ChartJS components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
)

const SkillsChart = ({ language = "Spanish" }) => {
  const [chartOptions, setChartOptions] = useState(null);
  
  // Site color palette
  const siteColors = {
    red: '#FF3A6E',
    orange: '#FF6D4B',
    green: '#55E6A5',
    purple: '#7B4AFF',
    blue: '#00B4DB',
  }
  
  // Sample data for skill distribution (pie chart)
  const skillDistributionData = {
    labels: ['Vocabulary', 'Grammar', 'Reading', 'Listening'],
    datasets: [
      {
        data: [40, 30, 20, 10], // Percentages
        backgroundColor: [
          siteColors.red,
          siteColors.orange,
          siteColors.green,
          siteColors.purple,
        ],
        borderWidth: 0,
      },
    ],
  }
  
  // Set up chart options based on screen size
  useEffect(() => {
    const updateChartOptions = () => {
      const isMobile = window.innerWidth < 768;
      
      setChartOptions({
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
          legend: {
            position: isMobile ? 'bottom' : 'right',
            labels: {
              color: '#FFFFFF',
              font: {
                family: 'Poppins',
                size: isMobile ? 10 : 12,
              },
              boxWidth: isMobile ? 10 : 15,
              padding: isMobile ? 10 : 15,
              usePointStyle: true,
            },
          },
          tooltip: {
            backgroundColor: '#2C2C2C',
            titleColor: '#FFFFFF',
            bodyColor: '#A0A0A0',
            borderColor: '#333333',
            borderWidth: 1,
            padding: 10,
            displayColors: true,
            callbacks: {
              label: function(context) {
                return `${context.label}: ${context.raw}%`;
              }
            }
          },
        },
      });
    };
    
    // Initial setup
    updateChartOptions();
    
    // Add event listener for resize
    window.addEventListener('resize', updateChartOptions);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', updateChartOptions);
    };
  }, []);
  
  // Initial options for SSR or before effect runs
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    plugins: {
      legend: {
        position: 'right',
        labels: {
          color: '#FFFFFF',
          font: {
            family: 'Poppins',
            size: 12,
          },
          boxWidth: 15,
          padding: 15,
          usePointStyle: true,
        },
      },
      tooltip: {
        backgroundColor: '#2C2C2C',
        titleColor: '#FFFFFF',
        bodyColor: '#A0A0A0',
        borderColor: '#333333',
        borderWidth: 1,
        padding: 10,
        displayColors: true,
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.raw}%`;
          }
        }
      },
    },
  };
  
  return (
    <div className="bg-[#1E1E1E] rounded-lg p-4">
      <h3 className="text-white font-semibold mb-4">{language} Skills</h3>
      <div className="flex items-center justify-center">
        <div className="w-full h-64 md:h-72 lg:max-w-md">
          <Doughnut 
            data={skillDistributionData} 
            options={chartOptions || defaultOptions} 
          />
        </div>
      </div>
    </div>
  )
}

export default SkillsChart